import AllWorkspaceList from './AllWorkspaceList';
export default AllWorkspaceList;